/**
 * Aggregate registry of all visualization definitions.
 *
 * Each per-viz file under this directory exports a single
 * `VisualizationDefinition`. This module collects them into
 * `ALL_VISUALIZATIONS` (the canonical ordered list) and a
 * type-keyed lookup map.
 */
// Layout (5)
import { rowDefinition } from './Row.js';
import { columnDefinition } from './Column.js';
import { dividerDefinition } from './Divider.js';
import { tabsDefinition } from './Tabs.js';
import { accordionDefinition } from './Accordion.js';
// Content (10)
import { textDefinition } from './Text.js';
import { metricDefinition } from './Metric.js';
import { badgeDefinition } from './Badge.js';
import { iconDefinition } from './Icon.js';
import { mermaidDefinition } from './Mermaid.js';
import { imageDefinition } from './Image.js';
import { progressDefinition } from './Progress.js';
import { calloutDefinition } from './Callout.js';
import { linkDefinition } from './Link.js';
import { codeDefinition } from './Code.js';
// Data-backed (15) — 11 chart variants + 4 non-chart data views
import { barChartDefinition } from './BarChart.js';
import { lineChartDefinition } from './LineChart.js';
import { areaChartDefinition } from './AreaChart.js';
import { pieChartDefinition } from './PieChart.js';
import { scatterPlotDefinition } from './ScatterPlot.js';
import { heatmapDefinition } from './Heatmap.js';
import { histogramDefinition } from './Histogram.js';
import { radarChartDefinition } from './RadarChart.js';
import { sankeyChartDefinition } from './SankeyChart.js';
import { funnelChartDefinition } from './FunnelChart.js';
import { gaugeChartDefinition } from './GaugeChart.js';
import { dataTableDefinition } from './DataTable.js';
import { kanbanDefinition } from './Kanban.js';
import { listDefinition } from './List.js';
import { sparklineDefinition } from './Sparkline.js';
// Interactive (6)
import { buttonDefinition } from './Button.js';
import { checkboxDefinition } from './Checkbox.js';
import { toggleDefinition } from './Toggle.js';
import { selectDefinition } from './Select.js';
import { textFieldDefinition } from './TextField.js';
import { sliderDefinition } from './Slider.js';
// Domain (2)
import { calendarDefinition } from './Calendar.js';
import { timelineDefinition } from './Timeline.js';
export const ALL_VISUALIZATIONS = [
    // Layout
    rowDefinition,
    columnDefinition,
    dividerDefinition,
    tabsDefinition,
    accordionDefinition,
    // Content
    textDefinition,
    metricDefinition,
    badgeDefinition,
    iconDefinition,
    mermaidDefinition,
    imageDefinition,
    progressDefinition,
    calloutDefinition,
    linkDefinition,
    codeDefinition,
    // Data-backed — chart variants
    barChartDefinition,
    lineChartDefinition,
    areaChartDefinition,
    pieChartDefinition,
    scatterPlotDefinition,
    heatmapDefinition,
    histogramDefinition,
    radarChartDefinition,
    sankeyChartDefinition,
    funnelChartDefinition,
    gaugeChartDefinition,
    // Data-backed — non-chart views
    dataTableDefinition,
    kanbanDefinition,
    listDefinition,
    sparklineDefinition,
    // Interactive
    buttonDefinition,
    checkboxDefinition,
    toggleDefinition,
    selectDefinition,
    textFieldDefinition,
    sliderDefinition,
    // Domain
    calendarDefinition,
    timelineDefinition,
];
const BY_TYPE = new Map(ALL_VISUALIZATIONS.map((def) => [def.type, def]));
export function getVisualization(type) {
    return BY_TYPE.get(type);
}
// Derived registry — was previously defined inline in component-catalog.ts.
// Lives here to avoid a circular import with the per-viz files above.
export const catalogSchemas = new Map(ALL_VISUALIZATIONS.map((def) => [def.type, def.propsSchema]));
export function getCatalogSchema(type) {
    return catalogSchemas.get(type);
}
//# sourceMappingURL=index.js.map